const embed = (param) => {
    let val = '';
    let caption = "";
    if (param.caption){
        caption = '<div class="block-image__description">'+ param.caption +'</div>';
    }
    val += `<div class="ratio ratio-16x9">
                <iframe style="border: none;" src='${param.embed}'
                        allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
                        frameborder="0"
                        allowfullscreen></iframe>
            </div>
            ${caption}
            `
    return val
}

module.exports = embed;
